import { render, staticRenderFns } from "./FieldForm.vue?vue&type=template&id=4b7e5c5a&scoped=true&"
import script from "./FieldForm.vue?vue&type=script&lang=js&"
export * from "./FieldForm.vue?vue&type=script&lang=js&"
import style0 from "./FieldForm.vue?vue&type=style&index=0&id=4b7e5c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e5c5a",
  null
  
)

export default component.exports